/* ============================================================
   KYBER COLLECTIVE — THEME JS
   ============================================================ */

(function () {
  'use strict';


  // ── SCROLL REVEAL ──
  const reveals = document.querySelectorAll('.kc-reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(el => observer.observe(el));
  } else {
    reveals.forEach(el => el.classList.add('visible'));
  }

  // ── PRODUCT VARIANT SELECTOR ──
  const variantSelects = document.querySelectorAll('[data-variant-select]');
  variantSelects.forEach(select => {
    select.addEventListener('change', () => {
      const form = select.closest('form');
      if (!form) return;
      const priceEl = document.querySelector('[data-product-price]');
      const selected = select.options[select.selectedIndex];
      if (priceEl && selected.dataset.price) {
        priceEl.textContent = selected.dataset.price;
      }
    });
  });

  // ── PRODUCT IMAGE GALLERY ──
  const thumbs = document.querySelectorAll('[data-thumb]');
  const mainImg = document.querySelector('[data-main-img]');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImg) {
        mainImg.src = thumb.dataset.src;
        mainImg.alt = thumb.alt;
      }
    });
  });

  // ── CART NOTIFICATION ──
  const cartForms = document.querySelectorAll('[data-add-to-cart]');
  cartForms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[data-submit-btn]');
      const originalText = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
      try {
        const formData = new FormData(form);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: formData.get('id'),
            quantity: parseInt(formData.get('quantity')) || 1
          })
        });
        if (res.ok) {
          await updateCartCount();
          showNotification('Item added to cart', 'success');
          if (btn) { btn.textContent = 'Added'; }
          setTimeout(() => {
            if (btn) { btn.textContent = originalText; btn.disabled = false; }
          }, 2000);
        }
      } catch (err) {
        if (btn) { btn.textContent = originalText; btn.disabled = false; }
        showNotification('Could not add item', 'error');
      }
    });
  });

  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const countEl = document.querySelector('.kc-cart-count');
      if (countEl) {
        countEl.textContent = cart.item_count;
        countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
    } catch (e) {}
  }

  function showNotification(msg, type) {
    let notif = document.querySelector('.kc-notification');
    if (!notif) {
      notif = document.createElement('div');
      notif.className = 'kc-notification';
      document.body.appendChild(notif);
      Object.assign(notif.style, {
        position: 'fixed', bottom: '24px', right: '24px', zIndex: '10000',
        fontFamily: "'Share Tech Mono', monospace", fontSize: '0.7rem',
        letterSpacing: '0.2em', textTransform: 'uppercase',
        padding: '12px 20px', border: '1px solid',
        background: 'rgba(0,0,0,0.9)', backdropFilter: 'blur(12px)',
        transition: 'opacity 0.3s ease, transform 0.3s ease',
        transform: 'translateY(10px)', opacity: '0'
      });
    }
    notif.textContent = '// ' + msg;
    notif.style.color = type === 'success' ? 'var(--kc-cyan)' : 'var(--kc-amber)';
    notif.style.borderColor = type === 'success' ? 'rgba(0,229,255,0.3)' : 'rgba(255,107,0,0.3)';
    requestAnimationFrame(() => {
      notif.style.opacity = '1';
      notif.style.transform = 'translateY(0)';
    });
    setTimeout(() => {
      notif.style.opacity = '0';
      notif.style.transform = 'translateY(10px)';
    }, 3000);
  }

  // ── INIT CART COUNT ──
  updateCartCount();

})();
